/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Rights_Restriction_DescInputs */

const es_privacy_policy_rights_restriction_desc = /** @type {(inputs: Privacy_Policy_Rights_Restriction_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitar el uso de su informacion en ciertas circunstancias`)
};

const en_privacy_policy_rights_restriction_desc = /** @type {(inputs: Privacy_Policy_Rights_Restriction_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limit the use of your information in certain circumstances`)
};

/**
* | output |
* | --- |
* | "Limit the use of your information in certain circumstances" |
*
* @param {Privacy_Policy_Rights_Restriction_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_rights_restriction_desc = /** @type {((inputs?: Privacy_Policy_Rights_Restriction_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Rights_Restriction_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_rights_restriction_desc(inputs)
	return en_privacy_policy_rights_restriction_desc(inputs)
});
export { privacy_policy_rights_restriction_desc as "privacy_policy.rights.restriction_desc" }